export default "__VITE_ASSET__Dy6jiiI6__"